export default "__VITE_ASSET__64878931__"